export default __webpack_public_path__ + "static/media/whatsapp-icon-square-rounded.16ba3f88.svg";